// extracted by mini-css-extract-plugin
var _1 = "HypIMYE5TfK7Lv1DMHnb";
var _2 = "AfomzP2x0cSPWApCU1ia";
var _3 = "_FNM8xpdWTyLVxulNbcX";
var _4 = "rTAjWJ6bEDtece7RnYkB";
var _5 = "JoLeTNfTkzk6wcgokzFY";
var _6 = "PAqeYACHyF4HzKltm2cj";
export { _1 as "foot", _2 as "info", _3 as "info_item", _4 as "info_list", _5 as "profile", _6 as "value" }
